import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_ADD_AFFILIATED_CARE_TEAM_MEMBER')